import { NavLink } from "react-router-dom";
import { useSite } from "@/lib/content";
import { t } from "@/lib/i18n";
import { Logo } from "@/components/Logo";
import MobileMenu from "@/components/MobileMenu";
import LangSwitcher from "@/components/LangSwitcher";
import { getNavItems } from "@/components/navItems";

export default function Header() {
  const { content, isPreview, site } = useSite();
  const items = getNavItems(content, isPreview, site);

  return (
    <header className="sticky top-0 z-40 bg-cream/95 backdrop-blur-md border-b border-line" data-testid="site-header">
      <div className="safe-x max-w-7xl mx-auto flex items-center justify-between h-[76px] lg:h-[88px]">
        <Logo className="h-[64px] lg:h-[74px] w-auto" />
        <nav aria-label={t("nav.main")} className="hidden lg:block">
          <ul className="flex items-center gap-1">
            {items.map((i) => (
              <li key={i.key}>
                <NavLink
                  to={i.to}
                  end={i.end}
                  data-testid={`nav-link-${i.key}`}
                  className={({ isActive }) =>
                    `inline-flex items-center min-h-[44px] px-4 rounded-full text-[15px] font-medium transition-colors duration-200 ${
                      isActive ? "text-forest bg-cream-2" : "text-ink-muted hover:text-forest"
                    }`
                  }
                >
                  {t(i.labelKey || `nav.${i.key}`)}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div className="flex items-center gap-2">
          <LangSwitcher testId="header-lang-switcher" />
          <MobileMenu items={items} />
        </div>
      </div>
    </header>
  );
}
